import mfDiscoverLoaderProgress from '../../assets/SVGS/mf-discover-loader-progress.svg'
import { cn } from '../../lib/utils'

function MFDiscoverButtonLoader({ className, ...props }) {
  return (
    <span
      role='status'
      aria-label='Loading'
      className={cn(
        'inline-flex h-6 w-16 shrink-0 items-center justify-center align-middle',
        className,
      )}
      {...props}
    >
      <img
        src={mfDiscoverLoaderProgress}
        alt=''
        aria-hidden='true'
        draggable='false'
        className='h-full w-full object-contain'
      />
    </span>
  )
}

export { MFDiscoverButtonLoader }
